const firebaseConfig = {
    apiKey: "AIzaSyAY0sCLwltfThR9rwVkpdWDGqvJE5SCxKc",
    authDomain: "p-hospital.firebaseapp.com",
    projectId: "p-hospital",
    storageBucket: "p-hospital.appspot.com",
    messagingSenderId: "486636661776",
    appId: "1:486636661776:web:40a0fa53b267b3c9606e95"
  };

export default firebaseConfig;